import { deleteAccessToken } from './accessToken';
import { deleteRefreshToken } from './refreshToken';
import { deleteExpiryTime } from './expiryTime';
import { deleteCountRefreshPage } from './countRefresgPage';

const resetAuthData = () => {
  deleteAccessToken();
  deleteRefreshToken();
  deleteExpiryTime();
  deleteCountRefreshPage();
};

export default resetAuthData;
